






























import Vue from 'vue'
import { ActionInterface, SwitchWithButtonElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'SwitchWithButtonEl',
  props: {
    templateItemData: {
      type: Object as () => SwitchWithButtonElInterface,
      required: true
    }
  },
  data: () => ({
    selected: false
  }),
  computed: {
    mainStyle (): string {
      return 'background: ' + this.templateItemData.background + '; --underline-color: ' +
        this.templateItemData.switch.textColor + ';'
    },
    buttonStyle (): string {
      return 'color: ' + this.templateItemData.button.textColor + ';'
    }
  },
  methods: {
    handleActionClick (action: ActionInterface): void {
      if (action.uri !== undefined) {
        this.getView(action.view, action.content || action.uri, null, action.jumpOnCloseUri)
      }
    },
    handleSwitchTextClick (event: Event): void {
      const link = event.target as HTMLInputElement

      if (link.closest('a')) {
        this.handleActionClick(
          this.templateItemData.switch.action
        )
      }
    }
  }
})
